module.exports = __webpack_public_path__ + "static/media/signup-img-5.9baf89e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/signup-img-5.jpg
// module id = 1409
// module chunks = 0